import io from 'socket.io-client'

// eslint-disable-next-line
const URL = process.env.NODE_ENV === 'development' ? 'http://localhost:3100' : (process.env.API_URL ? process.env.API_URL : 'https://api.spiry.ro')

const socket = io(URL)

export default socket